<template>
    <div id="contactus" class="parallax h-100" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="h-100">
            <div class="row justify-content-center">
                <div class="col text-center text-white pt-5">
                    <h1 class="lato-light">Get in touch</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4 offset-md-4 col-10 offset-1">
                    <form class="form" v-on:submit="submitGetInTouch">
                        <div class="form-group">
                            <input
                                type="text"
                                v-model="getInTouchForm.name"
                                class="form-control lato-light"
                                name="uname1"
                                id="uname1"
                                required="true"
                                placeholder="Your Name">
                        </div>
                        <div class="form-group">
                            <input
                                type="email"
                                v-model="getInTouchForm.email"
                                class="form-control"
                                name="email"
                                id="email"
                                required="true"
                                placeholder="Your Email">
                        </div>
                        <div class="form-group">
                            <input
                                type="text"
                                v-model="getInTouchForm.subject"
                                class="form-control"
                                name="subject"
                                id="subject"
                                required="true"
                                placeholder="Subject">
                        </div>
                        <div class="form-group">
                            <textarea
                                class="form-control"
                                v-model="getInTouchForm.message"
                                rows="6"
                                placeholder="Message">
                            </textarea>
                        </div>
                        <div class="form-group text-center">
                            <button class="btn btn-primary custom-btn pl-5 pr-5">
                              <span v-if="!isSubmitting">SEND</span>
                              <span v-if="isSubmitting">
                                <div class="spinner-border spinner-border-sm text-light"></div>
                              </span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import { TYPE } from "vue-toastification";
    import axios from "axios";

    export default {
        name: "GetInTouch",
        data: () => {
          return {
            getInTouchForm: {
              name: '',
              email: '',
              subject: '',
              message: ''
            },
            isSubmitting: false
          }
        },
        computed: mapGetters([
            'intersectionOptions'
        ]),
        methods: {
            ...mapActions([
                'setActiveTab',
            ]),
            onWaypoint({ going}) {
                if(going === 'in') {
                    this.setActiveTab('contactus');
                }
            },
          submitGetInTouch(e) {
              e.preventDefault();
              this.isSubmitting = true;
              let that = this;
              let url = process.env.VUE_APP_API_URL + '/api/affiliate/contact'
              axios.post(url, this.getInTouchForm).then((res) => {
                if (res.data.success) {
                  that.$toast("Your submission has been sent.", {
                    timeout: 2000,
                    type: TYPE.SUCCESS
                  });
                } else {
                  that.$toast("Error while sending your submission.", {
                    timeout: 2000,
                    type: TYPE.ERROR
                  });
                }
              }).catch((error) => {
                that.$toast("Error while sending your submission.", {
                  timeout: 2000,
                  type: TYPE.ERROR
                });
                console.log(error);
              }).finally(() => {
                that.getInTouchForm.name = '';
                that.getInTouchForm.email = '';
                that.getInTouchForm.subject = '';
                that.getInTouchForm.message = '';
                that.isSubmitting = false;
              })
          }
        }
    }
</script>

<style scoped>
    @media (min-width: 576px) {
        .parallax {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */
            height: 100vh;

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }
        h1 {
            font-size: calc(2.5rem + 5vmin);
            padding-bottom: 3rem;
        }
    }
    @media (max-width: 576px) {
        .parallax {
            /* The image used */
            background-image: url('~@/assets/home.png');

            /* Full height */
            height: 100vh;

            /* Create the parallax scrolling effect */
            background-attachment: fixed;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            background-color: rgb(28, 80, 87);
        }

        h1 {
            font-size: calc(1.5rem + 6vmin);
            padding-bottom: 1.5rem;
        }
    }

    .form-control{
        border-radius: 0px;
        border-color: white;
        border: 0px;
    }

    .btn-primary.custom-btn {
        background-color: #00C58A;
        border-color: #00C58A;
        color: white;
        font-family: Lato !important;
        font-weight: 700 !important;
    }

    input, textarea {
        font-family: Lato;
        font-weight: 300;
    }
</style>